export const PRIMARY_SELECTED_VAL = "main_cell";
